import { LegacyPathRedirect } from "src/components/LegacyPathRedirect";

export default LegacyPathRedirect;
